import { Controller } from "@hotwired/stimulus"

// Controlador para elementos <details> que deben cerrarse al hacer clic fuera
export default class extends Controller {
  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    document.addEventListener("click", this.closeOnClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
  }

  closeOnClickOutside(event) {
    // Si el clic fue fuera del elemento details, cerrarlo
    if (!this.element.contains(event.target)) {
      this.element.removeAttribute("open")
    }
  }
}
